import styled from 'styled-components';
import {
  MdDateRange,
  MdOutlineDoorFront,
  MdOutlineLocationOn,
} from 'react-icons/md';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
  padding: 24px 16px;
  background-color: ${props => props.theme.colors.white};
  margin: 0 16px;
  border-radius: 8px;
`;

export const InfoCard = styled.div`
  display: flex;
  gap: 16px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  height: 38px;
  background-color: ${props => props.theme.colors.blackShades(0.05)};
  border-radius: 50%;
`;

export const DateIcon = styled(MdDateRange)`
  color: ${props => props.color};
`;

export const LocationIcon = styled(MdOutlineLocationOn)`
  color: ${props => props.color};
`;

export const DestinationIcon = styled(MdOutlineDoorFront)`
  color: ${props => props.color};
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${props => props.theme.colors.secondary700};
  font-weight: 400;
  line-height: 1.2;
`;

export const Value = styled.p`
  margin: 0;
  font-size: 16px;
  color: ${props => props.theme.colors.highBlack};
  font-weight: 600;
  line-height: 1;
`;

export const DateValue = styled(Value)`
  font-size: 12px;
`;

export const LocationName = styled(Value)``;

export const LocationAddress = styled.a`
  margin: 0;
  font-size: 14px;
  color: ${props => props.color};
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:visited,
  &:active,
  &:focus {
    color: ${props => props.color};
    text-decoration: none;
  }
`;
